import { Button, Col, Form, Input, message, Row, Select } from "antd";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ContactInput from "../../components/ContactInput";
import country from "../../data/country";
import AxiosService from "../../services/APIService";
import leadLogo from "../../assets/whiteLogo.png";
import TriveImage from "../../assets/trive.svg";
import IntlPhoneInput from "../../components/IntlPhoneInput";

function AdminExhibitionForm() {
  const apiService = new AxiosService();
  //   const [searchParams] = useSearchParams();
  //   const white_label = searchParams.get("wlid");
  const [form] = Form.useForm();

  const [loading, setLoading] = useState({
    formLoading: false,
    otpLoading: false,
  });


  const onFinish = (val) => {
    setLoading({ ...loading, formLoading: true });
    apiService
      .post("/admin/exhibition-white-label", { ...val })
      .then((res) => {
        if (res?.success) {
          message.success("Lead Create Successfully");
          form.resetFields();
        }
      })
      .catch((e) => {
        message.error(e.message);
      })
      .finally(() => {
        setLoading({ ...loading, formLoading: false });
      });
  };
  return (
    <>
      <div className="main-layer-box">
        <div className="header-design">
          <div className="image-text-alignment">
            <img src={leadLogo} className="logo" />
            <h2>X</h2>
            <img src={TriveImage} alt="TriveImage" />
          </div>
        </div>
        <div className="center-alignment-box">
          <div className="alignment-top-bottom">
            <div className="top-bottom-alignment">
              <div className="spacing">
                <div className="text-style">
                  <h2>3 Months Free AI on your Live Trading Account</h2>
                  <h3>
                    Get 3 months of free access to PIP Pilots’ Expert Advisor
                    (EA).
                  </h3>
                  <p>
                    Experience a new era of Forex trading with us as we unlock
                    the potential of advanced EA and Martingale Strategy to
                    craft unparalleled success stories.
                  </p>
                  <h4>Simplified. Secured. Multiplied. </h4>
                </div>
                <div className="trial-text">
                  <p>Fill in your details below to activate your trial.</p>
                </div>
                <Form
                  name="lead"
                  onFinish={onFinish}
                  autoComplete="off"
                  layout="vertical"
                  form={form}
                >
                  <div className="bottom-spacing">
                    <Form.Item name="register_as">
                      <Select
                        placeholder="Select a Option"
                        size="large"
                        options={[
                          { value: "Broker", label: "Broker" },
                          { value: "SD", label: "SD" },
                          { value: "RM", label: "RM" },
                          { value: "TL", label: "TL" },
                          { value: "BDM", label: "BDM" },
                          { value: "IB", label: "IB" },
                          { value: "Investor", label: "Investor" },
                          { value: "Trader", label: "Trader" },
                        ]}
                      />
                    </Form.Item>
                  </div>
                  <div className="two-col-grid">
                    <Form.Item name="prefix">
                      <Select
                        placeholder="Select a Option"
                        defaultValue="Mr"
                        size="large"
                        options={[
                          { value: "Mr", label: "Mr" },
                          { value: "Ms", label: "Ms" },
                          { value: "Mrs", label: "Mrs" },
                        ]}
                      />
                    </Form.Item>
                    <Form.Item name="full_name">
                      <Input size="large" placeholder="Enter your full name" />
                    </Form.Item>
                  </div>
                  <div className="bottom-spacing">
                    <Form.Item name="phone_number">
                      <IntlPhoneInput
                        form={form}
                        name="phone_number"
                        placeholder="Enter your phone number"
                        required={false}
                        defaultCountry={"auto"}
                      />
                    </Form.Item>
                  </div>
                  <div className="bottom-spacing">
                    <Form.Item name="email">
                      <Input size="large" placeholder="Enter your email" />
                    </Form.Item>
                  </div>
                  <div className="two-col">
                    <Form.Item name="country">
                      <Select
                        showSearch
                        size="large"
                        placeholder="Select a Country"
                        options={[
                          ...new Set(country.map((item) => item.name)),
                        ].map((ctr) => ({
                          value: ctr,
                          label: ctr,
                        }))}
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .includes(input.toLowerCase()) ||
                          option.value
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                    <Form.Item name="city">
                      <Input size="large" placeholder="Enter your City" />
                    </Form.Item>
                  </div>
                  <Button
                    type="default"
                    htmlType="submit"
                    className="submit-btn"
                    block
                    size="large"
                    loading={loading.formLoading}
                  >
                    Submit
                  </Button>
                  <div className="last-text">
                    <p>Supported by Thrive</p>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default AdminExhibitionForm;
